import React from 'react'
import PropTypes from 'prop-types'

import { Message } from 'semantic-ui-react'

const ErrorMessage = ({ message }) => <Message content={message} header="Something went wrong" error />

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
}

export default ErrorMessage
